class Navbar {

    navbar;
    scrolledToTop = true;

    constructor() {
        this.navbar = document.querySelector('.navbar-default');
        document.addEventListener('scroll', this.scrollHandler.bind(this));
    }

    scrollHandler() {
        const scrolledToTop = !(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20);
        if (scrolledToTop !== this.scrolledToTop) {
            if (scrolledToTop) {
                this.navbar.classList.remove('navbar-color');
            } else {
                this.navbar.classList.add('navbar-color');
            }
            this.scrolledToTop = scrolledToTop;
        }
    }

}
